import React from 'react';
import './RetroCheckbox.css';

function RetroCheckbox({
  id,
  name,
  checked,
  onChange,
  disabled = false,
  label,
  className = '',
  ...props
}) {
  return (
    <label className={`retro-checkbox-wrapper ${className} ${disabled ? 'retro-checkbox-disabled' : ''}`}>
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="retro-checkbox"
        {...props}
      />
      {label && <span className="retro-checkbox-label">{label}</span>}
    </label>
  );
}

export default RetroCheckbox;
